import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field__error" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t('Checkout#Payment#Error Booking failed, session has expired. Please return and try again.')), 1))
}